export default __webpack_public_path__ + "static/media/1.dc90d3d7.png";